import store from '../../../store';

import Modal from '../../../components/common/dialog/dialog.vue';
import Lookup from '../../../components/common/lookup/lookup.vue';

import KeyboardHelper from '../../../helpers/keyboard.helper';
import l10n from '../../../transformers/l10n';

const OPTIONS = {
   showHeader: true,
   showFooter: false,
   showClose: false,

   headerText: '',

   confirmText: ''
};

const ENTER_CODE = 13;

export default {
   name: 'AddItemDialog',
   store,
   components: { Modal, Lookup },
   data() {
      return {
         items: [],
         text: '',
         selected: null,
         opts  : { ...OPTIONS, canConfirmChecker: () => !this.isDisabledSubmit }
      };
   },
   computed: {
      resolvedValue() {
         return this.selected || { name: this.text, type: this.type };
      },
      type() {
         return this.$options.type;
      },
      isDisabledSubmit() {
         if (this.$options.canCreateNewItem) {
            return !this.text;
         }
         return !this.selected;
      }
   },
   methods: {
      select([item]) {
         this.selected = item;
         this.text = item.name;
      },
      load(q) {
         this.selected = null;
         this.text = q;
         return this.$options.loader(this.type, q);
      },
      autoConfirm() {
         if ( !this.text ) {
            return;
         }
         this.$nextTick(() => {
            this.$emit('confirm');
         });
      }
   },
   mounted() {
      const name = l10n(`metadata.${this.type}_single`);
      this.opts.headerText = l10n('add_dialog.title', { name });

      this.$nextTick(() => {
         this._listeners = [
            KeyboardHelper.keydown(this.autoConfirm, ENTER_CODE, { stop: true, unshift: true, ignoreInput: false })
         ];
      });
   },
   destroyed() {
      this._listeners.forEach(off => off());
      this._listeners.length = 0;
   }
};
